import React, { useMemo } from "react";
import cx from "classnames";

import { Hooks } from "@xt/xtbase";

import store from "@/store";
import XtSvg, { type XtSvgProps } from "@/components/Xt/Svg";
import styles from "./index.module.scss";
import { observer } from "mobx-react-lite";
import NoData from "@/assets/icon-svg/withdraw/noData.svg";
import SvgIcon from "@xt/SvgIcon";

const { useTranslation } = Hooks;
export interface NoDataProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "style">, XtSvgProps {
  label?: string;
  noIcon?: boolean;
}

const AppDivNoData: React.FC<NoDataProps> = ({ label, noIcon, className, ...rest }) => {
  const t = useTranslation();

  const isDark = useMemo(() => {
    return store.app.theme.toLowerCase() === "dark";
  }, [store.app.theme]);
  return (
    <div className={cx(styles["empty-container"], styles[store.app.theme.toLowerCase()], className)} {...rest}>
      {!noIcon && <SvgIcon src={NoData} />}
      <div>{label || t("account.noData")}</div>
    </div>
  );
};

export default observer(AppDivNoData);
